export default function getUserAgent() {
  return globalThis.navigator?.userAgent || '';
};